import { motion } from "framer-motion";
import { Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import TabelaV2 from "../TabelaV2";
import RenderBodyNomeTabelaDesordenada from "./RenderBodyNomeTabelaDesordenada";

export const colunasEntrega = [
	{
		nomeColuna: "Pedido",
		field: "pedidoId",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Pedágio",
		field: "pedagio",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
];

function TableBodyDesordenado({
	data,
	striped,
	selecionado,
	nomeTable,
	linhaSelecionada,
	colunas,
	dadosEntrega,
	buscarOrdenacao,
	handleHover,
	handleSingleClick,
	handleDoubleClick,
	setDadosRastrearRedux,
	showDropDowEmbarques,
	setTabelaRedux,
	configDataHora,
	setColunaSelecionada,
	setOpenRegras,
	classeSelecionado,
	setOpen,
	isEmbarque,
	setIsEmbarque,
	setIsEntrega,
	configEntrega
}) {
	const { contextoEmbarque } = useProfile();

	const getMotionProps = (index) => ({
		whileHover: { backgroundColor: "#f0f8ff" },
		onHoverStart: () => {
			handleHover(index);
		},
		onHoverEnd: () => {
			handleHover(null);
		},
	});

	return (
		<tbody>
			{Array.isArray(data) &&
				data.map((row, rowIndex) => {
					return (
						<Fragment key={`Row-${row.idEmbarque}-${rowIndex}`}>
							<motion.tr
								key={`row-${rowIndex} ${row.idEmbarque}`}
								onClick={() => handleSingleClick(row)}
								onDoubleClick={() => handleDoubleClick(row)}
								whileHover={{
									backgroundColor: "#bebebe",
								}}
								className={`hover  ${striped && "striped"}
                                                            ${selecionado ===
									row[
									classeSelecionado
									] &&
									"selecionado"
									}
                                                            ${row.cte &&
									row.cte !==
									null &&
									row.cte !== "" &&
									row.cte !== " " &&
									row.cte !==
									"  " &&
									"cte"
									}
                                                            ${row.cancelado ===
									true &&
									"cancelado"
									}
                                                            ${row.foiCarregado ===
									false &&
									"cancelado"
									}
                                                            ${row.placaCavalo ===
									null &&
									"negrito-embarque"
									}`}
							>
								{nomeTable ? (
									<RenderBodyNomeTabelaDesordenada
										nomeTable={nomeTable}
										row={row}
										linhaSelecionada={linhaSelecionada}
										getMotionProps={getMotionProps}
										rowIndex={rowIndex}
										setDadosRastrearRedux={setDadosRastrearRedux}
										showDropDowEmbarques={showDropDowEmbarques}
										configDataHora={configDataHora}
										setColunaSelecionada={setColunaSelecionada}
										setOpenRegras={setOpenRegras}
										classeSelecionado={classeSelecionado}
										configEntrega={configEntrega}
									/>
								) : (
									<>
										{(colunas || []).map((col, colIndex) => {
											if (col.field === "freteFiscal") {
												if (row.freteFiscal !== null) {
													if (row?.pedido?.freteFiscal) {
														const floatValue = parseFloat(
															row.pedido.freteFiscal
														);

														return (
															<motion.td
																{...getMotionProps(colIndex)}
																key={`${row.pedido.freteFiscal}`}
																style={{ color: row.corCliente }}
															>
																{floatValue.toLocaleString("pt-BR", {
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																})}
															</motion.td>
														);
													}
													let value;
													if (typeof row[col.field] === "string") {
														value = row[col.field].replace(",", ".");
													}
													if ((value?.match(/\./g) || []).length > 1) {
														value = value.replace(".", "");
													}
													if (row.valorVariavelAlto) {
														if (isNaN(parseFloat(value))) {
															return (
																<motion.td
																	{...getMotionProps(colIndex)}
																	key={`col-${col.field}-${row[col.field]}-${row.id
																		}`}
																	style={{ color: row.corCliente }}
																	className="td-center-frete-fiscal"
																>
																	{row[col.field]}
																</motion.td>
															);
														} else {
															let floatValue = parseFloat(value);
															return (
																<motion.td
																	{...getMotionProps(colIndex)}
																	key={`col-${col.field}-${row[col.field]}-${row.id
																		}`}
																	style={{ color: row.corCliente }}
																	className="td-center-frete-fiscal"
																>
																	{floatValue.toLocaleString("pt-BR", {
																		minimumFractionDigits: 2,
																		maximumFractionDigits: 2,
																	})}
																</motion.td>
															);
														}
													} else {
														if (isNaN(parseFloat(value))) {
															return (
																<motion.td
																	{...getMotionProps(colIndex)}
																	key={`col-${col.field}-${row[col.field]}-${row.id
																		}`}
																	style={{ color: row.corCliente }}
																	className="td-right"
																>
																	{row[col.field]}
																</motion.td>
															);
														} else {
															let floatValue = parseFloat(value);
															return (
																<motion.td
																	{...getMotionProps(colIndex)}
																	key={`col-${col.field}-${row[col.field]}-${row.id
																		}`}
																	style={{ color: row.corCliente }}
																	className="td-right"
																>
																	{floatValue.toLocaleString("pt-BR", {
																		minimumFractionDigits: 2,
																		maximumFractionDigits: 2,
																	})}
																</motion.td>
															);
														}
													}
												}
											}
											if (col.field === "veiculoMotorista") {
												if (row.veiculoMotorista) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`col-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															{row.veiculoMotorista.nome}
														</motion.td>
													);
												}
											}
											if (col.field === "proprietario") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														style={{ color: row.corCliente }}
													>
														{row.proprietario}
													</motion.td>
												);
											}
											if (col.field === "pedido" || col.field === "nEntregas") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`col-${col.field}-${row[col.field]}-${row.id}`}
														style={{ color: row.corCliente }}
													>
														{row[col.field]}
													</motion.td>
												);
											}
											if (col.field === "usuarioResponsavel") {
												if (row.usuarioResponsavel) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`col-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															{row.usuarioResponsavel.usuario}
														</motion.td>
													);
												}
											}
											if (
												col.field === "dataHoraAcontecido" ||
												col.field === "dataHoraChegada" ||
												col.field === "dataHoraPrevisao" ||
												col.field === "data"
											) {
												if (
													row[col.field] === "2000-01-01T00:00:00" ||
													row[col.field] === null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`col-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`col-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															{new Date(row[col.field]).toLocaleDateString(
																"pt-BR",
																{
																	month: "numeric",
																	day: "numeric",
																	hour: "numeric",
																	minute: "numeric",
																}
															)}
														</motion.td>
													);
												}
											}
											if (col.field === "onTime") {
												if (row.onTime === true) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`col-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: "#48B43B" }}
														>
															On Time
														</motion.td>
													);
												} else if (row.onTime === null) {
													return (
														<motion.td {...getMotionProps(colIndex)}>
															Aguardando
														</motion.td>
													);
												} else {
													if (row.motivoOnTime !== null) {
														return (
															<motion.td
																{...getMotionProps(colIndex)}
																key={`col-${col.field}-${row[col.field]}-${row.id
																	}`}
																style={{ color: "#FF0000" }}
															>
																Ñ On Time
															</motion.td>
														);
													} else {
														return (
															<motion.td
																{...getMotionProps(colIndex)}
																key={`col-${col.field}-${row[col.field]}-${row.id
																	}`}
																style={{ color: "#FF0000" }}
															>
																Ñ On Time
															</motion.td>
														);
													}
												}
											}
											if (col.field === "motivoOnTime") {
												if (
													row.motivoOnTime !== undefined ||
													row.motivoOnTime !== null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`motivoOnTime-${row.id}-${row.motivoOnTime.motivo}`}
															style={{ color: row.corCliente }}
														>
															<span className="">
																{row.motivoOnTime.motivo}
															</span>
														</motion.td>
													);
												} else {
													if (row.onTime === false) {
														return (
															<motion.td
																{...getMotionProps(colIndex)}
																key={`motivoOnTime-${row.id}-${row.motivoOnTime.motivo}`}
																style={{ color: row.corCliente }}
															>
																<span
																	className="endereco"
																	style={{ color: "#5353ef" }}
																	onClick={() => {
																		const lista = [];
																		lista.push(row.embarque);
																		setTabelaRedux({
																			colunaSelecionada: row[classeSelecionado],
																			usuarioAlteracao: row.usuario,
																			dataAlteracao: row.data,
																			row: lista,
																		});
																		setOpen(true);
																		if (isEmbarque === true) {
																			setIsEmbarque(true);
																			setIsEntrega(false);
																		} else if (setIsEntrega) {
																			setIsEmbarque(false);
																			setIsEntrega(true);
																		}
																	}}
																>
																	{" "}
																	Adicionar
																</span>
															</motion.td>
														);
													}
												}
											}
											if (col.field === "nome") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`nome-${col.field}-${row[col.field]}-${row.id
															}`}
														style={{ color: row.corCliente }}
													>
														{row.nome}
													</motion.td>
												);
											}
											if (col.field === "cte") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`cte-${col.field}-${row[col.field]}-${row.id}`}
														style={{ color: row.corCliente }}
													>
														{row.cte}
													</motion.td>
												);
											}
											if (col.field === "icms") {
												if (row?.pedido?.icms) {
													return (
														<td
															key={`${row.pedido?.icms}`}
															style={{ color: row.corCliente }}
														>
															{row.pedido?.icms}
														</td>
													);
												}
											}
											if (col.field === "pedidoId") {
												return (
													<td
														key={`cte-${row.pedidoId} ${row.idEmbarque}`}
														style={{ color: row.corCliente }}
													>
														{row.pedido?.pedido}
													</td>
												);
											}
											if (col.field === "descricao") {
												if (contextoEmbarque === "templateEmbarque") {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`descricao-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															{row.descricao}
														</motion.td>
													);
												} else {
													return <Fragment key={uuidv4()} />;
												}
											}
											if (col.objetoUnidadeEmbarque === "true") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`objetoUnidadeEmb-${col.field}-${row[col.field]
															}-${row.id}`}
														style={{ color: row.corCliente }}
													>
														{row.cidadeEstado.cidade}
													</motion.td>
												);
											}
											if (col.tipo === "number") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`number-${col.field}-${row[col.field]}-${row.id
															}`}
														style={{ color: row.corCliente }}
														className="td-right"
													>
														{row[col.field]}
													</motion.td>
												);
											}
											if (col.field === "previsaoEmbarque") {
												if (
													row.previsaoEmbarque === "2000-01-01T00:00:00" ||
													row.previsaoEmbarque === null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`previsaoembarque-${col.field}-${row[col.field]
																}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`previsao-embarque-${col.field}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(
																row.previsaoEmbarque
															).toLocaleDateString("pt-BR", {
																month: "numeric",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "frota") {
												if (row.frota === true) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`frota-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															Sim
														</motion.td>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`frota-${col.field}-${row[col.field]}-${row.id
																}`}
															style={{ color: row.corCliente }}
														>
															Não
														</motion.td>
													);
												}
											}
											if (col.field === "notificarACadaData") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`notificarACadaData-${row.notificarACadaData}-${row.id}`}
														style={{ color: row.corCliente }}
													>
														{row.notificarACadaData}
													</motion.td>
												);
											}
											if (col.field === "tipoCheck") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`tipoCheck-${row.tipoCheck.nome}-${row.id}`}
														style={{ color: row.corCliente }}
													>
														{row.tipoCheck.nome}
													</motion.td>
												);
											}
											if (col.field === "dataCheckagem") {
												return (
													<motion.td
														{...getMotionProps(colIndex)}
														key={`dataCheckagem-${row.dataCheckagem}-${row.id}`}
														style={{ color: row.corCliente }}
														className="td-center"
													>
														{new Date(row.dataCheckagem).toLocaleDateString(
															"pt-BR",
															{
																year: "numeric",
																month: "numeric",
																day: "numeric",
															}
														)}
													</motion.td>
												);
											}
											if (col.field === "proximaRevisaoData") {
												if (row.proximaRevisaoData === null) {
													<motion.td
														{...getMotionProps(colIndex)}
														key={`proximaRevisaoData-${row.id}`}
														style={{ color: row.corCliente }}
													/>;
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`proximaRevisaoData-${row.proximaRevisaoData}-${row.id}`}
															style={{ color: row.corCliente }}
															className="td-center"
														>
															{new Date(
																row.proximaRevisaoData
															).toLocaleDateString("pt-BR", {
																year: "numeric",
																month: "numeric",
																day: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "notificarAutomatico") {
												if (row.notificarAutomatico === true) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`notificarAutomatico-${row.notificarAutomatico}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															Sim
														</motion.td>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`notificarAutomatico-${row.notificarAutomatico}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															Não
														</motion.td>
													);
												}
											}
											if (col.field === "cancelado") {
												if (row.cancelado === true) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`cancelado-${row.cancelado}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															Sim
														</motion.td>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`cancelado-${row.cancelado}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															Não
														</motion.td>
													);
												}
											}
											if (col.field === "previsaoEntrega") {
												if (
													row.previsaoEntrega === "2000-01-01T00:00:00" ||
													row.previsaoEntrega === null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`previsaoEntrega-${row.previsaoEntrega}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`previsaoEntrega-${row.previsaoEntrega}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(row.previsaoEntrega).toLocaleDateString(
																"pt-BR",
																{
																	month: "numeric",
																	day: "numeric",
																	hour: "numeric",
																	minute: "numeric",
																}
															)}
														</motion.td>
													);
												}
											}
											if (col.field === "dataHoraChegadaEmbarque") {
												if (
													row.dataHoraChegadaEmbarque === "2000-01-01T00:00:00"
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraChegadaEmbarque-${row.dataHoraChegadaEmbarque}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraChegadaEmbarque-${row.dataHoraChegadaEmbarque}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(
																row.dataHoraChegadaEmbarque
															).toLocaleDateString("pt-BR", {
																month: "numeric",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "dataHoraChegadaEntrega") {
												if (
													row.dataHoraChegadaEntrega ===
													"2000-01-01T00:00:00" ||
													row.dataHoraChegadaEntrega === null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraChegadaEntrega-${row.dataHoraChegadaEntrega}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraChegadaEntrega-${row.dataHoraChegadaEntrega}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(
																row.dataHoraChegadaEntrega
															).toLocaleDateString("pt-BR", {
																month: "numeric",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "dataHoraEntregue") {
												if (
													row.dataHoraEntregue === "2000-01-01T00:00:00" ||
													row.dataHoraEntregue === null
												) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraEntregue-${row.dataHoraEntregue}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraEntregue-${row.dataHoraEntregue}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(
																row.dataHoraEntregue
															).toLocaleDateString("pt-BR", {
																month: "numeric",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "dataHoraEmbarcado") {
												if (row.dataHoraEmbarcado === "2000-01-01T00:00:00") {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraEmbarcado-${row.dataHoraEmbarcado}-${row.id}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataHoraEmbarcado-${row.dataHoraEmbarcado}-${row.id}`}
															style={{ color: row.corCliente }}
														>
															{new Date(
																row.dataHoraEmbarcado
															).toLocaleDateString("pt-BR", {
																month: "numeric",
																day: "numeric",
																hour: "numeric",
																minute: "numeric",
															})}
														</motion.td>
													);
												}
											}
											if (col.field === "dataEntrega") {
												if (row.dataEntrega === "2000-01-01T00:00:00") {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
															className="td-center"
														>
															{new Date(row.dataEntrega).toLocaleDateString(
																"pt-BR",
																{
																	month: "numeric",
																	day: "numeric",
																}
															)}
														</motion.td>
													);
												}
											}
											if (col.field === "dataEmbarque") {
												if (row.dataEmbarque === "2000-01-01T00:00:00") {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
														/>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
															className="td-center"
														>
															{new Date(row.dataEmbarque).toLocaleDateString(
																"pt-BR",
																{
																	month: "numeric",
																	day: "numeric",
																}
															)}
														</motion.td>
													);
												}
											} else {
												if (isNaN(parseFloat(row[col.field]))) {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega1-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
														>
															{row[col.field]}
														</motion.td>
													);
												} else {
													return (
														<motion.td
															{...getMotionProps(colIndex)}
															key={`dataEntrega2-${row.dataEntrega}-${row.id}-${colIndex}`}
															style={{ color: row.corCliente }}
														>
															{parseFloat(row[col.field]).toLocaleString(
																"pt-BR",
																{
																	minimumFractionDigits: 2,
																	maximumFractionDigits: 2,
																}
															)}
														</motion.td>
													);
												}
											}
										})}
									</>
								)}
							</motion.tr>
							{linhaSelecionada.includes(row.idEmbarque) && (
								<tr key={`entregas-${row.idEmbarque}`}>
									<td colSpan="8">
										<TabelaV2
											classeSelecionado="entrega-embarque"
											nomeClasse1="outer-wrapper-rota"
											nomeClasse2="table-wrapper-entregas"
											colunas={colunasEntrega}
											dados={dadosEntrega[row.idEmbarque]}
											buscarOrdenacao={buscarOrdenacao}
										/>
									</td>
								</tr>
							)}
						</Fragment>
					);
				})}
		</tbody>
	);
}

export default TableBodyDesordenado;
